<script>
	import { navigate } from "svelte-routing";

	import { pageNumber, model } from "../stores";
	import { validator } from "../validation";
	import { registerPageComplete } from "../tealium";

	export let onSubmit = () => {};
	export let onNext = () => {};
	export let validate = null;
	export let persistUrl = "";
	export let showPrevious = false;
	export let showNext = true;
	export let previousPage = "";
	export let nextPage = "";
	export let previousPageLabel = "Previous";
	export let nextPageLabel = "Next";
	export let verifyCaptcha = false;
	export let tealiumTag = false;
	export let pageName = false;

	let basePath = window.basePath || "/";

	const basepath = basePath.lastIndexOf("/") != basePath.length - 1 ? basePath + "/" : basePath;

	let nextSpinnerClassName = null;
	let nextBtnDisabled = null;
	let previousBtnDisabled = null;

	const navigatePrevious = function () {
		console.log("Navigating Previous Page to:", previousPage);
		navigate(previousPage);
	};

	const isFormValid = function () {
		var validationScope = document.querySelector("form");

		if (validationScope === null) return [];

		return $validator.validateAll(validationScope);
	};

	const navigateNextAndPersistData = async function () {
		if (!persistUrl && validate === null) {
			navigateNext();
			return;
		}

		blockNavigationInput();

		var errors = isFormValid();
		if (errors.length === 0) {
			if (persistUrl) {
				var status = await model.persistJson(basepath + persistUrl);
				if (status) {
					onSubmit();
					navigateNext();
				}
			} else {
				navigateNext();
			}
		} else if (errors.length && errors.length > 0) {
			errors[0].scrollIntoView({ behavior: "smooth" });
		}

		unBlockNavigationInput();
	};

	const navigateNext = async () => {
		tealiumTag && (await registerPageComplete(pageName, $model.Contact.EmailAddress, $model.Contact.PhoneNumber));

		onNext();
		navigate(nextPage);

		console.log("Navigating Next Page to:", nextPage);

		window.scrollTo({ top: 0, behavior: "smooth" });
	};

	const unBlockNavigationInput = () => {
		nextSpinnerClassName = null;
		nextBtnDisabled = null;
		previousBtnDisabled = null;
	};

	const blockNavigationInput = () => {
		nextSpinnerClassName = "spinner-border spinner-border-sm";
		nextBtnDisabled = true;
		previousBtnDisabled = true;
	};

	const executeCaptcha = async function () {
		grecaptcha.ready(function () {
			grecaptcha.execute(projectSettings.gSiteKey, { action: "submit" }).then(async function (token) {
				let options = {
					method: "POST",
					headers: {
						"Content-type": "application/json"
					},
					body: JSON.stringify({ token: token })
				};

				var url = "/api/verify";
				let response = await fetch(`${url}`, options);
				if (response.ok) {
					let data = await response.json();

					if (data && data.status === true) {
						navigateNextAndPersistData();
					}
				}
			});
		});
	};

	const handleNextClick = () => {
		if (verifyCaptcha) {
			blockNavigationInput();
			executeCaptcha();
		} else {
			navigateNextAndPersistData();
		}
	};
</script>

<div class="btn-wrap" class:single={showPrevious == "false" || !showNext == "false"}>
	{#if showPrevious != "false"}
		<button
			class="btn btn-primary btn-page-nav {$$props.class}"
			disabled={previousBtnDisabled}
			on:click|preventDefault={() => {
				navigatePrevious();
			}}
		>
			{previousPageLabel}
		</button>
	{/if}

	{#if showNext != "false"}
		<button
			class="btn btn-primary btn-page-nav {$$props.class}"
			type="submit"
			disabled={nextBtnDisabled}
			on:click|preventDefault={() => {
				handleNextClick();
			}}
		>
			<span class={nextSpinnerClassName} role="status" aria-hidden="true"></span>
			{nextPageLabel}
		</button>
	{/if}
</div>

<style>
	.btn-wrap {
		display: flex;
		justify-content: space-between;
	}

	.btn-wrap .btn {
		width: 48%;
	}

	.btn-wrap.single {
		display: flex;
		justify-content: center;
	}

	.btn-page-nav {
		min-width: 143px;
	}

	.btn-wrap.single .btn {
		width: 100%;
	}

	@media (min-width: 768px) {
		.btn-page-nav {
			min-width: 191px;
		}

		.btn-wrap {
			display: block;
		}

		.btn-wrap .btn {
			width: auto;
		}

		.btn-wrap.single .btn {
			width: auto;
		}
	}
</style>
